module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 4_thumb.ad61a31f.jpg";